export class ProdutoImagemPreCadastroFormModel {
  constructor(public imagemUrl: string = "") {}
}
